<button *ngIf="showButton" type="button" class="btn btn-primary grid-button" (click)="openEventDetails()">
  <i class="material-icons">edit</i>
</button>
<div *ngIf="!showButton"></div>
